import { Alert } from "@mui/material";
import { RichTextFormat } from "containers/ProductDetailPage/AccordionInfo";
import parse from 'html-react-parser';
import { FC,useState } from "react";
import { useCollege } from "store/utils/hooks";
import MainNav2Logged from "./MainNav2Logged";

export interface HeaderLoggedProps {}

const HeaderLogged: FC<HeaderLoggedProps> = () => {
  const college = useCollege();
  const [displayNotification, setDisplayNotification] = useState<boolean>(true)
  console.log({college})
  return (
    <div className="nc-HeaderLogged sticky top-0 w-full z-40 ">
      <MainNav2Logged />
      {college?.notification && college?.notification !== '<p><br></p>' && college?.notification !== '<p></p>' && college?.notification !== `<p class="ql-align-justify"><br></p>` && college?.notification !== '<p><br></p><p><br></p>' && displayNotification && <div style={{backgroundColor:'rgb(255, 244, 229)'}}> <Alert severity="warning" className="items-center container" onClose={()=>setDisplayNotification(false)}>
        <RichTextFormat>
          {parse(college?.notification)}
        </RichTextFormat>
      </Alert></div>}
    </div>
  );
};

export default HeaderLogged;
